$(".menu-search > button").on("click", function () {
    var wrapper = $(this).parent();

    wrapper.toggleClass("active");

    if (wrapper.hasClass("active")){

        wrapper.find("input").focus();

    }else{

        wrapper.find("input").blur();

    }
});
